import { Route, Routes } from "react-router-dom";
import MainPage from "pages/MainPage";
import ErrorBoundary from 'components/ErrorBoundary/index'
function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <Routes>
          <Route path={"/"} element={<MainPage />} />
        </Routes>
      </ErrorBoundary>
    </div>
  );
}

export default App;
